var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{attrs:{"id":"modalWebTracking","title":_vm.$t('Personalizar web de tracking'),"no-close-on-backdrop":"","centered":"","modal-class":"dialog-1200","hide-footer":""}},[_c('Personalize')],1)}
var staticRenderFns = []

export { render, staticRenderFns }